"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpSensorFunction = void 0;
var __1 = require("..");
var rx_1 = require("../api/rx");
var rxjs_1 = require("rxjs");
var HttpSensorFunction = /** @class */ (function () {
    function HttpSensorFunction(url, credentials, gaiaClientFactory) {
        this.client = gaiaClientFactory.http(url + "/api/entity")
            .withCredentials(credentials)
            .build();
    }
    HttpSensorFunction.prototype.retrieve = function (config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(config); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve; });
    };
    HttpSensorFunction.prototype.retrieveKnowledge = function (config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (r) {
            r.knowledge(config);
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge; });
    };
    HttpSensorFunction.prototype.retrieveExperience = function (config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (r) { return r.experience(config); }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.experience; });
    };
    ;
    HttpSensorFunction.prototype.retrieveEdges = function (source, config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (r) {
            r.knowledge(function (k) { return k.edges(source, limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.edges; });
    };
    HttpSensorFunction.prototype.retrieveEdge = function (source, edgeId, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (r) {
            r.knowledge(function (k) { return k.edge(source, edgeId, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.edge; });
    };
    HttpSensorFunction.prototype.retrieveIdentities = function (config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (g) { return g.identities(limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.identities; });
    };
    HttpSensorFunction.prototype.retrieveIdentity = function (identityId, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (g) { return g.identity(identityId, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.identity; });
    };
    HttpSensorFunction.prototype.retrieveTenants = function (config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (g) { return g.tenants(limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.tenants; });
    };
    HttpSensorFunction.prototype.retrieveTenant = function (tenantId, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (g) { return g.tenant(tenantId, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.tenant; });
    };
    HttpSensorFunction.prototype.retrieveUsers = function (config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (g) { return g.users(limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.users; });
    };
    HttpSensorFunction.prototype.retrieveUser = function (userId, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (g) { return g.user(userId, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.user; });
    };
    HttpSensorFunction.prototype.retrieveApiKeys = function (config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (g) { return g.apiKeys(limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.apiKeys; });
    };
    HttpSensorFunction.prototype.retrieveApiKey = function (apiKeyId, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (g) { return g.apiKey(apiKeyId, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.apiKey; });
    };
    HttpSensorFunction.prototype.retrieveRoles = function (tenantId, config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (g) { return g.roles(tenantId, limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.roles; });
    };
    HttpSensorFunction.prototype.retrieveRole = function (tenantId, roleId, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (g) { return g.role(tenantId, roleId, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.role; });
    };
    HttpSensorFunction.prototype.retrieveIntents = function (identityId, config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (g) { return g.intents(identityId, limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.intents; });
    };
    HttpSensorFunction.prototype.retrieveIntent = function (identityId, reference, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (g) { return g.intent(identityId, reference, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.intent; });
    };
    HttpSensorFunction.prototype.retrievePrompts = function (identityId, config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.prompts(identityId, limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.prompts; });
    };
    HttpSensorFunction.prototype.retrievePrompt = function (identityId, reference, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.prompt(identityId, reference, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.prompt; });
    };
    HttpSensorFunction.prototype.retrieveStatements = function (identityId, config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.statements(identityId, limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.statements; });
    };
    HttpSensorFunction.prototype.retrieveStatement = function (identityId, reference, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.statement(identityId, reference, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.statement; });
    };
    HttpSensorFunction.prototype.retrieveFulfilments = function (identityId, config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.fulfilments(identityId, limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.fulfilments; });
    };
    HttpSensorFunction.prototype.retrieveFulfilment = function (identityId, reference, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.fulfilment(identityId, reference, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.fulfilment; });
    };
    HttpSensorFunction.prototype.retrieveCodes = function (identityId, config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.codes(identityId, limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.codes; });
    };
    HttpSensorFunction.prototype.retrieveCode = function (identityId, reference, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.code(identityId, reference, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.code; });
    };
    HttpSensorFunction.prototype.retrieveBehaviours = function (identityId, config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.behaviours(identityId, limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.behaviours; });
    };
    HttpSensorFunction.prototype.retrieveBehaviour = function (identityId, reference, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.behaviour(identityId, reference, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.behaviour; });
    };
    HttpSensorFunction.prototype.retrieveSkills = function (tenantId, config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.skills(tenantId, limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.skills; });
    };
    HttpSensorFunction.prototype.retrieveSkill = function (tenantId, reference, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.skill(tenantId, reference, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.skill; });
    };
    HttpSensorFunction.prototype.retrieveSkillProvisions = function (tenantId, config, limit, offset) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.skillProvisions(tenantId, limit, offset, undefined, undefined, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.knowledge.skillProvisions; });
    };
    HttpSensorFunction.prototype.retrieveSkillProvision = function (tenantId, reference, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.knowledge(function (k) { return k.skillProvision(tenantId, reference, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.knowledge.skillProvision; });
    };
    HttpSensorFunction.prototype.retrieveBehaviourExecution = function (identityId, processInstanceId, config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.experience(function (e) { return e.behaviourExecution(identityId, processInstanceId, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.experience.behaviourExecution; });
    };
    HttpSensorFunction.prototype.retrieveBehaviourExecutions = function (identityId, config, limit, offset, startDate, endDate) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.experience(function (e) { return e.behaviourExecutions(identityId, limit, offset, startDate, endDate, config); });
        }); })); });
        return rx_1.Rx.flatMapQ(observable, function (e) { return e.retrieve.experience.behaviourExecutions; });
    };
    HttpSensorFunction.prototype.retrieveIdentityMetrics = function (identityId, startDate, endDate, config, limit) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.retrieve(function (g) {
            g.experience(function (e) { return e.identityMetrics(identityId, startDate, endDate, limit, config); });
        }); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.retrieve.experience.identityMetrics; });
    };
    HttpSensorFunction.prototype.introspect = function (config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.introspect(config); })); });
        return rx_1.Rx.mapQ(observable, function (e) { return e.introspect; });
    };
    ;
    HttpSensorFunction.prototype.preserve = function (config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(config); })); });
        return rx_1.Rx.mapM(observable, function (e) { return e.preserve; });
    };
    HttpSensorFunction.prototype.preserveCreateIdentities = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.identities(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.tenantId();
                    d.qualifier();
                    d.availableLanguages();
                    d.languageOrder();
                    d.intentCascading();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.identities; });
    };
    HttpSensorFunction.prototype.preserveUpdateIdentities = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.update(function (_) { return _.identities(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.tenantId();
                    d.qualifier();
                    d.availableLanguages();
                    d.languageOrder();
                    d.intentCascading();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.update.identities; });
    };
    HttpSensorFunction.prototype.preserveDeleteIdentities = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.identities(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.identities; });
    };
    HttpSensorFunction.prototype.preserveCreateTenants = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.tenants(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.tenantId();
                    d.qualifier();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.tenants; });
    };
    HttpSensorFunction.prototype.preserveUpdateTenants = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.update(function (_) { return _.tenants(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.tenantId();
                    d.qualifier();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.update.tenants; });
    };
    HttpSensorFunction.prototype.preserveDeleteTenants = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.tenants(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.tenantId();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.tenants; });
    };
    HttpSensorFunction.prototype.preserveCreateUsers = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.users(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.userId();
                    d.username();
                    d.email();
                    d.firstName();
                    d.lastName();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.users; });
    };
    HttpSensorFunction.prototype.preserveUpdateUsers = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.update(function (_) { return _.users(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.userId();
                    d.username();
                    d.email();
                    d.firstName();
                    d.lastName();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.update.users; });
    };
    HttpSensorFunction.prototype.preserveDeleteUsers = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.users(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.userId();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.users; });
    };
    HttpSensorFunction.prototype.preserveCreateApiKeys = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.apiKeys(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.apiKeyId();
                    d.name();
                    d.description();
                    d.secret();
                    d.enabled();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.apiKeys; });
    };
    HttpSensorFunction.prototype.preserveUpdateApiKeys = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.update(function (_) { return _.apiKeys(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.apiKeyId();
                    d.name();
                    d.description();
                    d.enabled();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.update.apiKeys; });
    };
    HttpSensorFunction.prototype.preserveDeleteApiKeys = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.apiKeys(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.apiKeyId();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.apiKeys; });
    };
    HttpSensorFunction.prototype.preserveCreateRoles = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.roles(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.tenantId();
                    d.roleId();
                    d.name();
                    d.permissions();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.roles; });
    };
    HttpSensorFunction.prototype.preserveUpdateRoles = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.update(function (_) { return _.roles(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.tenantId();
                    d.roleId();
                    d.name();
                    d.permissions();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.update.roles; });
    };
    HttpSensorFunction.prototype.preserveDeleteRoles = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.roles(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.tenantId();
                    d.roleId();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.roles; });
    };
    HttpSensorFunction.prototype.preserveCreateIntents = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.intents(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.utterance();
                    d.labelList();
                    d.version();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.intents; });
    };
    HttpSensorFunction.prototype.preserveUpdateIntents = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.update(function (_) { return _.intents(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.utterance();
                    d.labelList();
                    d.version();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.update.intents; });
    };
    HttpSensorFunction.prototype.preserveDeleteIntents = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.intents(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.intents; });
    };
    HttpSensorFunction.prototype.preserveCreatePrompts = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.prompts(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.utterance();
                    d.labelList();
                    d.version();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.prompts; });
    };
    HttpSensorFunction.prototype.preserveUpdatePrompts = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.update(function (_) { return _.prompts(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.utterance();
                    d.labelList();
                    d.version();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.update.prompts; });
    };
    HttpSensorFunction.prototype.preserveDeletePrompts = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.prompts(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.prompts; });
    };
    HttpSensorFunction.prototype.preserveCreateStatements = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.statements(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.utterance();
                    d.labelList();
                    d.version();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.statements; });
    };
    HttpSensorFunction.prototype.preserveUpdateStatements = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.update(function (_) { return _.statements(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.utterance();
                    d.labelList();
                    d.version();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.update.statements; });
    };
    HttpSensorFunction.prototype.preserveDeleteStatements = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.statements(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.statements; });
    };
    HttpSensorFunction.prototype.preserveCreateSkills = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.skills(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.tenantId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.labelList();
                    d.repositoryUri();
                    d.repositoryType();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.skills; });
    };
    HttpSensorFunction.prototype.preserveUpdateSkills = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.update(function (_) { return _.skills(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.tenantId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.labelList();
                    d.repositoryUri();
                    d.repositoryType();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.update.skills; });
    };
    HttpSensorFunction.prototype.preserveDeleteSkills = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.skills(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.tenantId();
                    d.reference();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.skills; });
    };
    HttpSensorFunction.prototype.preserveCreateSkillProvisions = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.skillProvisions(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.tenantId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.labelList();
                    d.version();
                    d.skillRef();
                    d.cpu();
                    d.memory();
                    d.replicas();
                    d.enabled();
                    d.environment();
                    d.bootstrapTimeout();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.skillProvisions; });
    };
    HttpSensorFunction.prototype.preserveUpdateSkillProvisions = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.update(function (_) { return _.skillProvisions(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.tenantId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.labelList();
                    d.version();
                    d.skillRef();
                    d.cpu();
                    d.memory();
                    d.replicas();
                    d.enabled();
                    d.environment();
                    d.bootstrapTimeout();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.update.skillProvisions; });
    };
    HttpSensorFunction.prototype.preserveDeleteSkillProvisions = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.skillProvisions(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.tenantId();
                    d.reference();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.skillProvisions; });
    };
    HttpSensorFunction.prototype.preserveCreateFulfilments = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.fulfilments(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.utterance();
                    d.labelList();
                    d.version();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.fulfilments; });
    };
    HttpSensorFunction.prototype.preserveUpdateFulfilments = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.update(function (_) { return _.fulfilments(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.utterance();
                    d.labelList();
                    d.version();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.update.fulfilments; });
    };
    HttpSensorFunction.prototype.preserveDeleteFulfilments = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.fulfilments(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.fulfilments; });
    };
    HttpSensorFunction.prototype.preserveCreateBehaviours = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.behaviours(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.behaviour();
                    d.labelList();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.behaviours; });
    };
    HttpSensorFunction.prototype.preserveUpdateBehaviours = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.update(function (_) { return _.behaviours(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.behaviour();
                    d.labelList();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.update.behaviours; });
    };
    HttpSensorFunction.prototype.preserveDeleteBehaviours = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.behaviours(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.behaviours; });
    };
    HttpSensorFunction.prototype.preserveCreateCodes = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.codes(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.code();
                    d.type();
                    d.labelList();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.codes; });
    };
    HttpSensorFunction.prototype.preserveUpdateCodes = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.update(function (_) { return _.codes(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                    d.qualifier();
                    d.appendent();
                    d.code();
                    d.type();
                    d.labelList();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.update.codes; });
    };
    HttpSensorFunction.prototype.preserveDeleteCodes = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.codes(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.identityId();
                    d.reference();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.codes; });
    };
    HttpSensorFunction.prototype.preserveCreateEdges = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.create(function (_) { return _.edges(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.source();
                    d.target();
                    d.type();
                    d.weight();
                    d.edgeId();
                    d.properties();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.create.edges; });
    };
    HttpSensorFunction.prototype.preserveDeleteEdges = function () {
        var _this = this;
        var impulses = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            impulses[_i] = arguments[_i];
        }
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.delete(function (_) { return _.edges(impulses, function (i) {
                i.id();
                i.data(function (d) {
                    d.source();
                    d.edgeId();
                });
            }); });
        }); })); });
        return rx_1.Rx.flatMapM(observable, function (e) { return e.preserve.delete.edges; });
    };
    HttpSensorFunction.prototype.preserveConnectNodeSet = function (nodeId, impulse) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.connect(function (c) {
                c.node(nodeId, function (n) {
                    n.set(impulse, function (s) {
                        s.id();
                        s.removedEdges(function (e) {
                            e.source();
                            e.edgeId();
                        });
                        s.newEdge(function (e) {
                            e.source();
                            e.target();
                            e.edgeId();
                            e.type();
                            e.weight();
                            e.properties();
                        });
                    });
                });
            });
        }); })); });
        return rx_1.Rx.mapM(observable, function (e) { return e.preserve.connect.node.set; });
    };
    HttpSensorFunction.prototype.preserveConnectNodeUnset = function (nodeId, impulse) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.connect(function (c) {
                c.node(nodeId, function (n) {
                    n.unset(impulse, function (s) {
                        s.id();
                        s.removedEdges(function (e) {
                            e.source();
                            e.edgeId();
                        });
                    });
                });
            });
        }); })); });
        return rx_1.Rx.mapM(observable, function (e) { return e.preserve.connect.node.unset; });
    };
    HttpSensorFunction.prototype.preserveConnectNodeAppend = function (nodeId, impulse) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.connect(function (c) {
                c.node(nodeId, function (n) {
                    n.append(impulse, function (s) {
                        s.id();
                        s.newEdge(function (e) {
                            e.source();
                            e.target();
                            e.edgeId();
                            e.type();
                            e.weight();
                            e.properties();
                        });
                    });
                });
            });
        }); })); });
        return rx_1.Rx.mapM(observable, function (e) { return e.preserve.connect.node.append; });
    };
    HttpSensorFunction.prototype.preserveConnectNodeRemove = function (nodeId, impulse) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.preserve(function (p) {
            p.connect(function (c) {
                c.node(nodeId, function (n) {
                    n.remove(impulse, function (s) {
                        s.id();
                        s.removedEdges(function (e) {
                            e.source();
                            e.edgeId();
                        });
                    });
                });
            });
        }); })); });
        return rx_1.Rx.mapM(observable, function (e) { return e.preserve.connect.node.remove; });
    };
    HttpSensorFunction.prototype.perceive = function (config) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) { return q.perceive(config); })); });
        return rx_1.Rx.mapM(observable, function (e) { return e.perceive; });
    };
    HttpSensorFunction.prototype.perceiveAction = function (impulse) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) {
            q.perceive(function (p) { return p.perceiveAction(impulse, function (a) { return a.id(); }); });
        })); });
        return rx_1.Rx.mapM(observable, function (e) { return e.perceive.perceiveAction; });
    };
    HttpSensorFunction.prototype.perceiveData = function (impulse) {
        var _this = this;
        var observable = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (q) {
            q.perceive(function (p) { return p.perceiveData(impulse, function (a) { return a.id(); }); });
        })); });
        return rx_1.Rx.mapM(observable, function (e) { return e.perceive.perceiveData; });
    };
    HttpSensorFunction.prototype.introspectBuildJobs = function (tenantId, config) {
        var _this = this;
        if (config) {
            var obs_1 = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.introspect(function (i) { return i.buildJobs(tenantId, config); }); })); });
            return rx_1.Rx.flatMapQ(obs_1, function (e) { return e.introspect.buildJobs; });
        }
        var obs = rxjs_1.defer(function () { return _this.client.query(__1.GaiaRequest.query(function (q) { return q.introspect(function (i) { return i.buildJobs(tenantId, function (c) {
            c.tenantId();
            c.name();
            c.reference();
            c.created();
            c.skillRef();
            c.tag();
            c.status(function (s) {
                s.health();
                s.running();
                s.pending();
                s.failures(function (f) {
                    f.reason();
                    f.exitCode();
                    f.affectedContainer();
                });
            });
        }); }); })); });
        return rx_1.Rx.flatMapQ(obs, function (e) { return e.introspect.buildJobs; });
    };
    HttpSensorFunction.prototype.practice = function (config) {
        var _this = this;
        var obs = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (m) { return m.practice(config); })); });
        return rx_1.Rx.mapM(obs, function (m) { return m.practice; });
    };
    HttpSensorFunction.prototype.practiceBuild = function (impulse, config) {
        var _this = this;
        if (config === void 0) { config = undefined; }
        if (config) {
            var obs_2 = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (m) { return m.practice(function (p) { return p.build(impulse, config); }); })); });
            return rx_1.Rx.mapM(obs_2, function (m) { return m.practice.build; });
        }
        var obs = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (m) { return m.practice(function (p) { return p.build(impulse, function (c) {
            c.id();
            c.data(function (j) {
                j.name();
                j.reference();
                j.tenantId();
                j.tag();
            });
        }); }); })); });
        return rx_1.Rx.mapM(obs, function (m) { return m.practice.build; });
    };
    HttpSensorFunction.prototype.practiceCancel = function (impulse, config) {
        var _this = this;
        if (config === void 0) { config = undefined; }
        if (config) {
            var obs_3 = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (m) { return m.practice(function (p) { return p.cancel(impulse, config); }); })); });
            return rx_1.Rx.mapM(obs_3, function (m) { return m.practice.cancel; });
        }
        var obs = rxjs_1.defer(function () { return _this.client.mutation(__1.GaiaRequest.mutation(function (m) { return m.practice(function (p) { return p.cancel(impulse, function (c) {
            c.id();
            c.data(function (j) {
                j.name();
                j.reference();
                j.tenantId();
                j.tag();
            });
        }); }); })); });
        return rx_1.Rx.mapM(obs, function (m) { return m.practice.cancel; });
    };
    return HttpSensorFunction;
}());
exports.HttpSensorFunction = HttpSensorFunction;
//# sourceMappingURL=HttpSensorFunction.js.map